var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      {
        ref: "formWrapper",
        staticClass: "flex flex-wrap items-start justify-center m-auto mb-3",
        class: _vm.isTwoColumnLayout ? "md:max-w-xl" : "md:max-w-lg"
      },
      _vm._l(
        _vm.$store.state.data.Steps[_vm.$store.state.activeStep].Form,
        function(input, index) {
          return _c("vpf-input", {
            key: input.Label,
            ref:
              input.FieldType === "input" ||
              input.FieldType === "email" ||
              input.FieldType === "text" ||
              input.FieldType === "textarea" ||
              input.FieldType === "tel"
                ? "textInput"
                : null,
            refInFor: true,
            attrs: {
              type: input.FieldType || "text",
              placeholder: input.Placeholder,
              "is-required": input.Required,
              label: input.Label,
              "error-message": input.ErrorMessage,
              name: input.Name,
              id: input.Id,
              value: _vm.$store.state.userInputs[input.SalesforcePropertyKey]
            },
            on: {
              inputWasChanged: function($event) {
                return _vm.handleErrors($event, index)
              },
              input: function($event) {
                return _vm.updateInput($event, input.SalesforcePropertyKey)
              }
            }
          })
        }
      ),
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "flex items-center justify-evenly flex-col md:max-w-3xl m-auto"
      },
      [
        _c(
          "vpf-button",
          {
            attrs: { "is-disabled": _vm.form.isInvalid },
            nativeOn: {
              click: function($event) {
                return _vm.setNextStep()
              }
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$store.state.data.Steps[_vm.$store.state.activeStep]
                    .ButtonTextNext
                ) +
                "\n    "
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }